import React, { useState } from 'react';
import './Portfolio.css';

const Portfolio = () => {
    const [correntBtn, setCorrentBtn] = useState(1);
    
    const handleBtnClick = (id) => {
        setCorrentBtn(id);
    }
    return (
        <div className="portfolio-deep"> 
        <div className="portfolio-root container mx-auto mt-5 pt-4">
            <p data-aos="fade-up" className="portfolio-text">PORTFOLIOS</p>
            <div className="portfolio-head">
                <h1 data-aos="fade-up">All Creative Works!</h1>
                <div className="d-flex align-items-center new-root">
                    <p data-aos="fade-up" className="new px-2 py-1">New</p>
                    <p data-aos="fade-up" className="new-right">Explore all project on <span className="text-c-primary">Dribble</span></p>
                </div>
            </div>
            <div data-aos="fade-up" className="d-flex option-bar">
                {
                    correntBtn == 1 ? 
                    <div  onClick={() => handleBtnClick(1)} className="py-1 disable-btn px-2">Mobile apps</div>
                    :
                    <div  onClick={() => handleBtnClick(1)} className="py-1 correntBtn px-2">Mobile apps</div>
                }
                {
                    correntBtn == 2 ? 
                    <div  onClick={() => handleBtnClick(2)} className="py-1 disable-btn px-2">Mobile apps</div>
                    :
                    <div  onClick={() => handleBtnClick(2)} className="py-1 correntBtn px-2">Mobile apps</div>
                }
                {
                    correntBtn == 3 ? 
                    <div  onClick={() => handleBtnClick(3)} className="py-1 disable-btn px-2">Mobile apps</div>
                    :
                    <div  onClick={() => handleBtnClick(3)} className="py-1 correntBtn px-2">Mobile apps</div>
                }
                {
                    correntBtn == 4 ? 
                    <div  onClick={() => handleBtnClick(4)} className="py-1 disable-btn px-2">Mobile apps</div>
                    :
                    <div  onClick={() => handleBtnClick(4)} className="py-1 correntBtn px-2">Mobile apps</div>
                }
                {
                    correntBtn == 5 ? 
                    <div  onClick={() => handleBtnClick(5)} className="py-1 disable-btn px-2">Mobile apps</div>
                    :
                    <div  onClick={() => handleBtnClick(5)} className="py-1 correntBtn px-2">Mobile apps</div>
                }
                
            </div>
            <div className="row portfolio-images">
                <div className="col-md-4 port-col-1">
                    <div className="port-1"></div>
                    <div className="port-2"></div>
                </div>
                <div className="col-md-4">
                    <div className="port-3"></div>
                    <div className="port-4"></div>
                </div>
                <div className="col-md-4">
                    <div className="port-5"></div>
                    <div className="port-6"></div>
                </div>
            </div>
        </div>
        </div>
    );
};

export default Portfolio;